import { pageBannerTop, menuLang } from '../layout';
import Collapse from 'bootstrap/js/dist/collapse';
document.addEventListener("DOMContentLoaded", function(){
	pageBannerTop();
	menuLang();
});